import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
const INSIGHT = 'insight'

const getDrillDownKpiData = (filters: {
  idMetric: number;
  dateFrom: string;
  dateTo: string;
  idCompanyList?: number[];
  idDocTypeList?: number[];
  idGbsList?: number[];
  idGeoList?: number[];
  incChannelList?: number[];
}) => {
  return trackPromise(
    axios.post<{
      protocols: number[];
      idTemplate: number;
      idProgram: number;
      idUser: number;
      idGroupEquals: number | null;
      idGroupIn: number[];
      allAuthorized: boolean;
    }>(`${INSIGHT}/getDrillDownParameters`, { ...filters }),
    'module',
  );
};

export default { getDrillDownKpiData };
